export default "__VITE_PUBLIC_ASSET__7a57494d__"